<div
  data-slot="empty-header"
  class="empty-header"
  [ngClass]="className"
>
  <ng-content></ng-content>
</div>
